import styled from "@emotion/styled";

export const LogbookItemContainer = styled.div`
  width: 70%;
  padding: 15px;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.colors.logbookSectionBg[0]};
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  cursor: move;
  user-select: none;
`;
